import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SignUp.css";

import {
  getAuth,
  signInWithEmailAndPassword,
  sendEmailVerification,
  signInWithPopup
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import {
  db,
  googleProvider,
  facebookProvider
} from "../firebase"; // ✅ 匯入 provider

const DASHBOARD_ROUTE = {
  Kid: "/UserProfile/StudentProfile",
  Parent: "/ParentsDashboard",
  Assistant: "/UserProfile/AssistantProfile",
};

export default function Login() {
  const [loginType, setLoginType] = useState("Parent");
  const [email, setEmail] = useState("");
  const [accountName, setAccountName] = useState("");
  const [parentCode, setParentCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [resendMsg, setResendMsg] = useState("");

  const navigate = useNavigate();
  const auth = getAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setResendMsg("");

    try {
      let cred, fakeEmail;
      if (loginType === "Parent") {
        cred = await signInWithEmailAndPassword(auth, email, password);
        if (!cred.user.emailVerified) {
          setError("Please verify your email before logging in. (Check spam/junk folder too)");
          setResendMsg("Didn't get the email? ");
          return;
        }
      } else {
        if (!accountName || !parentCode || !password)
          return setError("All fields are required.");
        fakeEmail = `kid-${accountName}-${parentCode}@koalaquest.ca`;
        cred = await signInWithEmailAndPassword(auth, fakeEmail, password);
      }

      const snap = await getDoc(doc(db, "users", cred.user.uid));
      if (!snap.exists()) throw new Error("User profile not found");

      const { accountType = "Kid" } = snap.data();
      const to = DASHBOARD_ROUTE[accountType] || "/";
      navigate(to, { replace: true });
    } catch (err) {
      console.error(err);
      setError("Invalid credentials or verification required.");
    }
  };

  const handleResendVerification = async () => {
    try {
      const user = getAuth().currentUser;
      if (user && !user.emailVerified) {
        await sendEmailVerification(user);
        setResendMsg("Verification email sent. Please check your inbox (and spam)!");
      }
    } catch (err) {
      setResendMsg("Could not resend verification email, please try again later.");
    }
  };

  // ✅ 通用社群登入邏輯（for Google / Facebook）
  const handleSocialLogin = async (provider) => {
    setError("");
    try {
      const cred = await signInWithPopup(auth, provider);
      const snap = await getDoc(doc(db, "users", cred.user.uid));
      if (!snap.exists()) throw new Error("User profile not found");

      const { accountType = "Kid" } = snap.data();
      const to = DASHBOARD_ROUTE[accountType] || "/";
      navigate(to, { replace: true });
    } catch (err) {
      console.error(err);
      setError("Social login failed or user not registered.");
    }
  };

  return (
    <div className="signup-page-container">
      <div className="signup-form-container">
        <h2 className="signup-form-title">Log In</h2>

        {/* 登入身份切換 */}
        <div className="login-type-tabs" style={{ marginBottom: 20 }}>
          <button
            className={loginType === "Parent" ? "login-type-active" : ""}
            onClick={() => setLoginType("Parent")}
            style={{ marginRight: 8 }}
          >
            Parent
          </button>
          <button
            className={loginType === "Kid" ? "login-type-active" : ""}
            onClick={() => setLoginType("Kid")}
          >
            Kid
          </button>
        </div>

        {error && <p className="signup-form-error">{error}</p>}
        {resendMsg && (
          <p style={{ color: "#226", marginTop: -10, marginBottom: 10 }}>
            {resendMsg}
            <button type="button" onClick={handleResendVerification} style={{ marginLeft: 10 }}>
              Resend Verification Email
            </button>
          </p>
        )}

        {/* Email-based 登入表單 */}
        <form onSubmit={handleSubmit}>
          {loginType === "Parent" && (
            <>
              <div className="signup-input-container">
                <input value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" required />
                <label>Email</label>
              </div>
              <div className="signup-input-container">
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" required />
                <label>Password</label>
              </div>
            </>
          )}

          {loginType === "Kid" && (
            <>
              <div className="signup-input-container">
                <input value={accountName} onChange={e => setAccountName(e.target.value)} required />
                <label>Account Name (Kid Username)</label>
              </div>
              <div className="signup-input-container">
                <input maxLength={6} value={parentCode} onChange={e => setParentCode(e.target.value)} required />
                <label>Parent Code</label>
              </div>
              <div className="signup-input-container">
                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" required />
                <label>Password</label>
              </div>
            </>
          )}

          <button type="submit" className="signup-submit-button">Log In</button>
        </form>

        {/* ✅ 加入社群登入按鈕 */}
        <div style={{ marginTop: 24 }}>
          <hr />
          <p style={{ textAlign: "center", margin: "12px 0", fontWeight: "bold" }}>
            Or log in with:
          </p>
          <button onClick={() => handleSocialLogin(googleProvider)} className="guest-social-login google">Google</button>
        </div>
      </div>
    </div>
  );
}
